// test923
(923 && 0);
